import { z } from 'zod';

// ---------------------------------------------------------------------------
// Aviso de privacidad versionado (research R-7; contracts/staff-api.md)
// ---------------------------------------------------------------------------

/** Versión vigente la fija `PRIVACY_NOTICE_VERSION` en la API (p. ej. `2026-09`). */
export const PrivacyNoticeVersionSchema = z.string().min(1).max(40);
export type PrivacyNoticeVersion = z.infer<typeof PrivacyNoticeVersionSchema>;

/**
 * `POST /activation/{token}/privacy` y `POST /privacy/accept`: `{ version }`.
 * Versión distinta a la vigente → `400 VALIDATION_ERROR` con
 * `details.issues: [{ path: 'version', … }]` (`modules/privacy/service.ts`
 * `assertCurrentPrivacyVersion`); no hay `422` en el catálogo de errores.
 */
export const AcceptPrivacyBodySchema = z.object({
  version: PrivacyNoticeVersionSchema,
});
export type AcceptPrivacyBody = z.infer<typeof AcceptPrivacyBodySchema>;

/** Estado del aviso en `StaffMe.privacy_notice`: `pending` si la última aceptación no es la vigente. */
export const PrivacyNoticeStateSchema = z.object({
  version: PrivacyNoticeVersionSchema,
  pending: z.boolean(),
});
export type PrivacyNoticeState = z.infer<typeof PrivacyNoticeStateSchema>;
